import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { Spinner } from 'reactstrap';
import 'dayjs/locale/sv';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

import { IFile } from 'services/filesService';
import './CustomerFiles.css';
import { useState } from 'react';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.locale('sv');

export type ICustomerFilesProps = {
  items?: IFile[];
  onDownload?: (fileId: number, fileName: string) => Promise<void>;
};

const CustomerFiles = function ({ items, onDownload }: ICustomerFilesProps) {
  const [isLoading, setIsLoading] = useState<Record<number, boolean>>({ 0: false });

  const { t } = useTranslation('translation');

  const onDownloadClick = async (fileId: number, fileName: string) => {
    if (!onDownload) return;

    setIsLoading((prev) => ({ ...prev, [fileId]: true }));
    await onDownload(fileId, fileName);
    setIsLoading((prev) => ({ ...prev, [fileId]: false }));
  };

  return (
    <div className="row">
      <div className="col fullwidth-table-container collapsable-table-md">
        <Table hover className="default" striped={true}>
          <thead>
            <tr>
              {/* Was added from Joakim, but it does not make sense */}
              <th>{t('filearea.FILENAME')}</th>
              <th>{t('filearea.CREATED')}</th>
            </tr>
          </thead>
          <tbody>
            {items &&
              items.map((i: IFile) => (
                <tr key={i.id}>
                  <td>
                    <span className="collapsed-title">{t('filearea.FILENAME')}: </span>
                    {!isLoading[i.id] && (
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => onDownloadClick(i.id, i.fileName)}
                      >
                        {i.fileName}
                      </a>
                    )}
                    {isLoading[i.id] && <Spinner />}
                  </td>
                  <td>
                    <span className="collapsed-title">{t('filearea.CREATED')}: </span>
                    {dayjs(i.created).format('YYYY-MM-DD')}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default connect()(CustomerFiles);
